import React from 'react'

const OwnerInfo = () => (
  <div className='OpenListingCard-item OpenListingCard-item--width100px'>
    <div className='OpenListingCard-title'>Owner</div>
  </div>
)

export default OwnerInfo
